<template>
  <div>
    <div class="d-flex justify-center mt-8 mx-6" v-if="step === 1">
      <v-expansion-panels v-model="expansion_ativo" accordion>
        <v-expansion-panel class="expansion-panel">
          <v-expansion-panel-header class="expansion-panel-header">
            Adicionar itens por filtro
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <div class="d-flex">
              <div class="position-absolute mt-n5" style="color: #73787F">
                Selecione 1 ou mais filtros e clique em “Buscar e adicionar itens”. Itens já presentes não serão
                duplicados.
              </div>

              <div class="mt-8 w-100-porcento">
                <div class="d-flex align-center">
                  <div class="w-50-porcento pr-2">
                    <SysFornecedorAutocomplete
                      v-model="filtros_local.fornecedores"
                      :ids-segmento="filtros_local.segmentos"
                      :ids-comprador="filtros_local.compradores"
                      :qtde-visivel-selecionados="1"
                      label="Fornecedor"
                      append-icon="$CaretDown"
                      outlined
                      multiple
                      hide-details
                      clearable
                    />
                  </div>

                  <div class="w-50-porcento pl-2">
                    <SysSegmentoAutocomplete
                      v-model="filtros_local.segmentos"
                      :qtde-visivel-selecionados="1"
                      label="Segmento"
                      append-icon="$CaretDown"
                      outlined
                      multiple
                      hide-details
                      clearable
                    />
                  </div>
                </div>

                <div class="d-flex align-center mt-5">
                  <div class="w-50-porcento pr-2">
                    <SysMarcaAutocomplete
                      v-model="filtros_local.marcas"
                      :qtde-visivel-selecionados="1"
                      label="Marca"
                      append-icon="$CaretDown"
                      outlined
                      multiple
                      hide-details
                      clearable
                    />
                  </div>

                  <div class="w-50-porcento pl-2">
                    <SysLinhasAutocomplete
                      v-model="filtros_local.linhas"
                      :qtde_visivel_selecionados="1"
                      label="Linha"
                      append-icon="$CaretDown"
                      outlined
                      multiple
                      hide-details
                      clearable
                    />
                  </div>
                </div>

                <div class="d-flex align-center mt-5">
                  <div class="w-50-porcento pr-2">
                    <SysCompradorAutocomplete
                      v-model="filtros_local.compradores"
                      :ids-segmento="filtros_local.segmentos"
                      :qtde_visivel_selecionados="1"
                      label="Comprador"
                      append-icon="$CaretDown"
                      outlined
                      multiple
                      hide-details
                      clearable
                    />
                  </div>
                </div>

                <div class="d-flex py-6 justify-end align-center">
                  <SysTooltip2
                    text="Use filtros para incluir um grupo de produtos (ex.: fornecedor, categoria, marca)."
                    left
                  >
                    <template #activator>
                      <a
                        class="btn-class-outlined-filtros bra-6 mr-6"
                        @click="emitBuscarAdicionarItens()"
                      >
                        Buscar e adicionar itens
                      </a>
                    </template>
                  </SysTooltip2>
                </div>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class="mx-6 px-6 py-7 mt-6 border-gray-400 bra-6" v-if="step === 1">
      <h2 style="color: #0D0D0E; font-weight: 500">Itens selecionados</h2>
      <p class="mt-3">Você começou a configuração pelo produto:
        <b>{{ produto_inicial ? produto_inicial.id_produto : null }} –
          {{ produto_inicial ? produto_inicial.descricao_produto : null }}</b>
      </p>

      <div class="d-flex justify-start align-center">
        <div class="w-20-porcento">
          <v-text-field
            v-model="pesquisa_termo"
            class="input-pesquisa"
            hide-details
            outlined
            dense
            clearable
            label="Buscar no escopo"
            prepend-inner-icon="$MagnifyingGlass"
          />
        </div>

        <SysTooltip2 text="A configuração será aplicada em todos os itens desta lista." right>
          <template #activator>
          <span class="ml-8 flag-produtos-selecionados" :class="flagProdutosClass">
            <span class="contador-produtos-selecionados" :class="flagProdutosClass">
              {{ produtos_selecionados.length }}
            </span> produto selecionado(s)
          </span>
          </template>
        </SysTooltip2>
      </div>

      <div class="mt-5">
        <SysDataTable
          v-if="produtos_selecionados.length > 0"
          :search="pesquisa_termo"
          :headers="headers"
          :items="produtos_selecionados"
          item-key="index"
          :height="250"
          class="pl-2"
          :item-height="55"
          :item-class="corLinha"
          hide-default-footer
        >

          <template #item.descricao_produto="{item}">
            <div class="d-flex align-center">
              {{item.descricao_produto}}

              <RodadasCompraProdutoBadge
                :rodadas="item.rodadas_compra"
                :produto_inicial="produto_inicial"
              />
            </div>
          </template>

          <template #item.acoes="{item}">
            <v-icon
              color="#39404B"
              size="28"
              alt="trash.btn"
              @click="() => $emit('excluir:produto', item)"
            >
              $Trash
            </v-icon>
          </template>
        </SysDataTable>

        <div
          class="d-flex justify-center align-center flex-column mt-16 pl-2"
          v-else
        >
          <v-icon size="80" color="#CFD1D7">$Basket</v-icon>

          <h3 class="my-1 font-weight-medium" style="color: #19191C">Não há itens selecionados</h3>
          <p style="color: #73787F">Use os filtros para adicionar filtros na compra sazonal</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from "vue";

import SysDataTable from "@/components/utils/dataTable/sysDataTable/Index.vue";
import SysLinhasAutocomplete from "@/components/utils/crud/SysLinhasAutocomplete.vue";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete.vue";
import SysTooltip2 from "@/components/utils/ui_v4/tooltips/SysTooltip2.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";

import RodadasCompraProdutoBadge
  from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/AplicacaoTipoProjecao/CompraSazonal/components/badge/RodadasCompraProdutoBadge.vue";

const emit = defineEmits(['buscar:adicionar-itens', 'excluir:produto', 'update:filtros']);

const props = defineProps({
  step: {
    type: Number,
    required: true
  },
  filtros: {
    type: Object,
    required: true
  },
  produtos_selecionados: {
    type: Array,
    required: true
  },
  produto_inicial: {
    type: [Object, null],
    required: true
  }
});

const filtros_local = reactive({
  fornecedores: [],
  segmentos: [],
  marcas: [],
  linhas: [],
  compradores: []
});

watch(
  filtros_local,
  () => emit('update:filtros', { ...filtros_local }),
  { deep: true }
);

const pesquisa_termo = ref("");

const flagProdutosClass = computed(() => ({
  'has-products': props.produtos_selecionados.length > 0,
  'nohas-products': props.produtos_selecionados.length === 0
}));

const expansion_ativo = ref(false);
const headers = [
  { text: 'Cod. Interno', value: 'id_produto' },
  { text: 'Produto', value: 'descricao_produto' },
  { text: 'Fornecedor', value: 'fornecedor' },
  { text: 'Segmento', value: 'segmento' },
  { text: 'Ações', value: 'acoes' }
];

function emitBuscarAdicionarItens() {
  emit('buscar:adicionar-itens');
  expansion_ativo.value = false;
}

function corLinha(item) {
  return { 'text-gray-400': 1 === 1 };
}
</script>

<style scoped>
.flag-produtos-selecionados {
  color: #19191C;
  padding: 9px 100px 9px 25px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 17px;
}

.flag-produtos-selecionados.has-products {
  background-color: #E6FBEB;
}

.flag-produtos-selecionados.nohas-products {
  background-color: #F2F6FC;
}

.contador-produtos-selecionados.has-products {
  color: #0CB935;
}
.expansion-panel {
  border: 1px solid #E2E2E4;
  border-radius: 6px;
  overflow: hidden;
  min-height: 60px;
}

.expansion-panel .v-expansion-panel-content__wrap,
.expansion-panel .v-expansion-panel-text {
  background: #fff;
}

.expansion-panel-header {
  margin-top: 4px;
  font-weight: 500;
  font-size: 20px;
}

.btn-class-outlined-filtros {
  border: 1px solid #8CACFF;
  color: #4075FF;
  text-transform: none;
  font-weight: 500;
  padding: 8px 13px;

  &:hover {
    color: #275ef1;
    border: 1px solid #5e87fd;
  }
}
</style>
